import { render } from "./WagetypeWorktype.vue?vue&type=template&id=3c9f1f0c"
import script from "./WagetypeWorktype.vue?vue&type=script&lang=js"
export * from "./WagetypeWorktype.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__